import { render, staticRenderFns } from "./SourceSelector.vue?vue&type=template&id=9ff44168&scoped=true"
import script from "./SourceSelector.vue?vue&type=script&lang=ts"
export * from "./SourceSelector.vue?vue&type=script&lang=ts"
import style0 from "./SourceSelector.vue?vue&type=style&index=0&id=9ff44168&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff44168",
  null
  
)

export default component.exports